export default {
  isLoggedIn: false,
  token: null,
  user: {},
  ready: false,
  metaReady: false,
  ometaReady: false,
}
